import React from 'react'
import { Badge, Box, useTheme } from '@mui/material'
import AddLinkIcon from '@mui/icons-material/AddLink'
import DoneIcon from '@mui/icons-material/Done'
import PandaIconSvg from './panda-icon-svg'

interface GenerateLinksIconProps {
  disabled: boolean
  isCompleted: boolean
  size?: number
}

const GenerateLinksIcon = ({ disabled, isCompleted, size = 45 }: GenerateLinksIconProps) => {
  const theme = useTheme()
  return (
    <Badge
      badgeContent={
        isCompleted ? <DoneIcon fontSize="small" sx={{ color: 'text.success', zIndex: 20 }} /> : <AddLinkIcon />
      }
      color="secondary"
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <Box
        sx={{
          opacity: isCompleted ? 0.5 : disabled ? 0.2 : 1,
        }}
      >
        <PandaIconSvg
          size={size}
          bgColor={isCompleted ? theme.palette.background.defaultdim : theme.palette.icon.pandadoc}
          fgColor={isCompleted ? theme.palette.icon.pandadoc : theme.palette.text.primary}
        />
      </Box>
    </Badge>
  )
}
export default GenerateLinksIcon
